module.exports = __webpack_public_path__ + "img/banner-line_compact.2edf0f11.png";